import { gql } from '@apollo/client';

export const EscrowInvitationFields = gql`
  fragment EscrowInvitationFields on EscrowInvitation {
    id
    status
    companyName
    partyType
    user {
      id
      name
      email
      phone
    }
    policy {
      accept
      reject
      update
    }
    userName
    userEmail
    escrow {
      id
    }
  }
`;
